import { Expandable, ExpandableGroup, FoldPanel, Specimens, Stack, Typography } from '@src/components';

export function ExpandableSection() {
  return (
    <FoldPanel
      id="expandables"
      title="Expandables"
      hint="A FAQ list. A small lavender help mark, hairline rows, and a circle whose plus turns into a close mark as the answer opens."
      example={`<ExpandableGroup defaultOpenIndex={1}>
  <Expandable title="I am not getting emails. What should I do?">
    Check spam, then add us to your trusted senders. You can also
    sign in with a social account — nothing critical lives only in mail.
  </Expandable>
</ExpandableGroup>`}
    >
      <Specimens
        label="FAQ group"
        note="One open at a time. Click a plus — it rotates into an X while the answer expands."
      >
        <ExpandableGroup defaultOpenIndex={1}>
          <Expandable title="I organise the game, but I cannot see Draw. What should I do?">
            You need at least two people with a card. Refresh the game once everyone has joined.
          </Expandable>
          <Expandable title="I am not getting emails. What should I do?">
            <Stack gap={3}>
              <Typography as="p" role="body/sm">
                Some mail services are strict about spam and can drop our letters. Check the spam
                folder and add us to your trusted senders.
              </Typography>
              <Typography as="p" role="body/sm">
                You can also sign in with a social account. We only mail for things that matter — the
                draw, a new giftee. Everything is still on the site if a letter never arrives.
              </Typography>
            </Stack>
          </Expandable>
          <Expandable title="I filled in my card. When do I find out who I gift?">
            After the organiser runs the draw. You will see your giftee on this site, and we send a
            note if we have a way to reach you.
          </Expandable>
          <Expandable title="Can I stop two people drawing each other?">
            Yes. Set exceptions before the draw, or assign a giftee yourself as the organiser.
          </Expandable>
        </ExpandableGroup>
      </Specimens>

      <Specimens
        label="On its own"
        note="No group — each panel keeps its own open state. Hide the help mark with icon={false}."
      >
        <Stack gap={0} wide>
          <Expandable title="A single question, no group" defaultOpen>
            Useful when the page only has one fold, or when several can stay open at once.
          </Expandable>
          <Expandable title="Without the help mark" icon={false}>
            Hide the leading mark when the row is not a question.
          </Expandable>
        </Stack>
      </Specimens>
    </FoldPanel>
  );
}
